/**
 * Did this drawer session change anything the PACKAGE owns? Compares only
 * formula / exclusion rules / capacity — interval, weights and run-state are
 * campaign-local and never prompt the package question.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowOptimizerConfig } from '@trafficpulse/shared';

export function packageContentChanged(
  persisted: FlowOptimizerConfig,
  draft: FlowOptimizerConfig,
): boolean {
  const half = (c: FlowOptimizerConfig) =>
    JSON.stringify({
      formula: c.formula,
      excludeRules: c.excludeRules,
      capacityRules: c.capacityRules ?? [],
    });
  return half(persisted) !== half(draft);
}

/** Prompt only when the PERSISTED config already belongs to this package —
 *  a package freshly loaded into the draft is the review-first flow and
 *  saves without questions. */
export function shouldAskPackageSave(
  persisted: FlowOptimizerConfig,
  draft: FlowOptimizerConfig,
): boolean {
  return Boolean(
    draft.mode === 'CUSTOM' &&
      draft.packageId &&
      persisted.packageId === draft.packageId &&
      packageContentChanged(persisted, draft),
  );
}
